<div class="card setting">
  <div class="second-factor-section">
    <img src="/assets/images/twoFA_security.svg" alt="2FA" />
    <div class="setting-description">
      <h3>Autenticación de dos factores</h3>
      <p>
        La autenticación de dos factores cumple la función de agregar una capa adicional de
        seguridad al inicio de sesión en tu cuenta. Te recomendamos utilizar esta herramienta para
        mayor seguridad.
      </p>
    </div>
    <mat-slide-toggle
      #twoFAToggle
      [ngClass]="twoFAActivated ? 'activated' : 'deactivated'"
      [checked]="twoFAActivated"
      (change)="toggle2FA()"
      [(ngModel)]="twoFAActivated"
      labelPosition="before"
    >
      {{ twoFAActivated ? 'Activado' : 'Desactivado' }}
    </mat-slide-toggle>
  </div>
  <div class="divider"></div>
  <div class="password-section">
    <div class="title-box">
      <p class="password-title">Cambio de contraseña</p>
    </div>
    <div class="setting-description">
      <p>Actualizá tu contraseña para tener tu cuenta más segura.</p>
    </div>
    <button class="td-btn disabled" (click)="openChangePasswordComponent('')">Cambiar</button>
  </div>
</div>
